import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import './Templates.scss'

@observer
class Templates extends Component {

  componentDidMount(){
    this.props.getTemplates()
  }

  render() {
    const templates = this.props.templatesList.map( item => {
      const templateRoute = item.add.map( point => {
        return (<li>{point.streetName2}, {point.streetNumber2}</li>)
      })

      return (
        <li className="templates__item" key={item.id}>
          <div className="templates__item-title">{item.nameTemplate}</div>
          <div>
            <ul className={item.add.length > 0 ? "with-route": ""}>
              <li>{item.streetName}, {item.streetNumber}</li>
              {templateRoute}
            </ul>
          </div>
          
          <button class="btn-delete" onClick={() => this.props.delTemplete(item.id)}>*</button>
        </li>
      )
      
    })
    return (
      <>
        <ul className="templates-list">
          {templates}
        </ul>
      </>
    )
  }
}

const withData = inject(stores => ({
  templatesList: stores.TemplatesStore.templatesList,
  getTemplates: stores.TemplatesStore.getTemplates,
  delTemplete: stores.TemplatesStore.delTemplete,
}))

export default withData(Templates);
